import { BlocksIconNote } from 'blocks-nextjs/blocks-web-components/components/icon/icons/note';
import React from 'react';
import { createComponent } from '../../CustomWrapper/CustomWrapper';

export const CatIconNote = createComponent({ react: React, tagName: 'cat-icon-note', elementClass: BlocksIconNote });
